var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E0E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.806 8.161.827 9.922A1 1 0 0 0 8.63 19h7.192a1 1 0 0 0 .996-.917l.827-9.922M5 8.161h14m-3.161-.451-1.51-2.265A1 1 0 0 0 13.497 5h-2.994a1 1 0 0 0-.832.445L8.16 7.71"
  })));
};
export default SvgDelete;